export enum ReportScheduleType {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}
